(() => {
  "use strict";
  if (!window.Lymko || window.__lk_product) return;
  window.__lk_product = 1;
  const { $, $$, reduced, esc, money, toast, addItems, openO, closeAll, reveal, markFavs, store, R, CFG } = window.Lymko;
  const T = window.Lymko.T || ((k, d) => d);
  function productPage() {
    const root = $("[data-product]");
    if (!root || root.dataset.lkBound) return;
    root.dataset.lkBound = 1;
    const gm = $("#gmain"), sl = $("#slides"), slides = $$(".sl", sl), thumbs = $$("#thumbs button");
    const n = slides.length;
    let g = 0;
    thumbs.forEach((b, i) => b.dataset.g = i);
    const mob = () => matchMedia("(max-width:780px)").matches;
    const count = () => {
      const c = $("#gc");
      if (c) c.textContent = `${g + 1} / ${n}`;
    };
    /* Zoom: click / tap to zoom in at that point, click / tap again to zoom out, +/- buttons and keys,
       zoom follows the mouse on desktop, drag to pan and pinch to zoom on touch. Works on every slide (ritual artwork too). */
    const MAXZ = 4, STEP = 2.5;
    let Z = 1, ox = 0, oy = 0, moved = false;
    const clampN = (v, a, b) => Math.max(a, Math.min(b, v));
    const box = () => gm.getBoundingClientRect();
    gm.insertAdjacentHTML("beforeend", '<div class="lk-zb"><button type="button" data-z="-1" aria-label="Zoom out">−</button><button type="button" data-z="1" aria-label="Zoom in">+</button></div>');
    const zb = () => {
      const o = $('[data-z="-1"]', gm), i = $('[data-z="1"]', gm);
      if (o) o.disabled = Z <= 1;
      if (i) i.disabled = Z >= MAXZ;
    };
    const paint = (anim) => {
      const s = slides[g];
      slides.forEach((x) => {
        if (x !== s) {
          x.style.transform = "";
          x.style.transition = "";
        }
      });
      if (!s) return;
      s.style.transition = anim ? "" : "none";
      s.style.transformOrigin = `${ox}px ${oy}px`;
      s.style.transform = Z > 1 ? `scale(${Z})` : "";
      gm.classList.toggle("zoomed", Z > 1);
      zb();
    };
    const setZ = (z, cx, cy) => {
      const r = box();
      if (cx != null) {
        ox = clampN(cx - r.left, 0, r.width);
        oy = clampN(cy - r.top, 0, r.height);
      } else if (Z <= 1) {
        ox = r.width / 2;
        oy = r.height / 2;
      }
      Z = clampN(z, 1, MAXZ);
      if (Z < 1.05) Z = 1;
      paint(true);
    };
    const unzoom = () => {
      Z = 1;
      slides.forEach((x) => {
        x.style.transform = "";
        x.style.transition = "";
      });
      gm.classList.remove("zoomed");
      zb();
    };
    zb();
    const go = (i) => {
      unzoom();
      g = (i + n) % n;
      if (mob()) sl.scrollTo({ left: sl.clientWidth * g, behavior: reduced ? "auto" : "smooth" });
      else sl.style.transform = `translateX(-${g * 100}%)`;
      thumbs.forEach((b, j) => {
        b.classList.toggle("on", j === g);
        b.setAttribute("aria-current", j === g);
      });
      count();
    };
    count();
    if (n < 2) {
      $$(".garr").forEach((b) => b.hidden = true);
    }
    $("#gl").addEventListener("click", () => go(g - 1));
    $("#gr").addEventListener("click", () => go(g + 1));
    $("#thumbs").addEventListener("click", (e) => {
      const b = e.target.closest("[data-g]");
      if (b) go(+b.dataset.g);
    });
    sl.addEventListener("scroll", () => {
      if (!mob() || Z > 1) return;
      const i = Math.round(sl.scrollLeft / sl.clientWidth);
      if (i !== g) {
        g = i;
        thumbs.forEach((b, j) => b.classList.toggle("on", j === g));
        count();
      }
    }, { passive: true });
    gm.addEventListener("click", (e) => {
      const b = e.target.closest("[data-z]");
      if (!b) return;
      e.stopPropagation();
      setZ(Z + Number(b.dataset.z) * 0.75);
    });
    sl.addEventListener("click", (e) => {
      if (moved) {
        moved = false;
        return;
      }
      if (e.target.closest("a, button, video, iframe")) return;
      if (Z > 1) unzoom();
      else setZ(STEP, e.clientX, e.clientY);
    });
    gm.addEventListener("pointermove", (e) => {
      if (e.pointerType !== "mouse" || Z <= 1 || e.target.closest(".lk-zb, .garr")) return;
      const r = box();
      ox = clampN(e.clientX - r.left, 0, r.width);
      oy = clampN(e.clientY - r.top, 0, r.height);
      const s = slides[g];
      if (s) s.style.transformOrigin = `${ox}px ${oy}px`;
    });
    gm.addEventListener("pointerleave", (e) => {
      if (e.pointerType === "mouse" && Z > 1) unzoom();
    });
    const dist = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    let t0 = null, pinch = null;
    gm.addEventListener("touchstart", (e) => {
      moved = false;
      if (e.touches.length === 2) {
        const [a, b] = e.touches;
        if (Z <= 1) {
          const r = box();
          ox = clampN((a.clientX + b.clientX) / 2 - r.left, 0, r.width);
          oy = clampN((a.clientY + b.clientY) / 2 - r.top, 0, r.height);
        }
        pinch = { d: dist(a, b) || 1, z: Z };
        t0 = null;
        return;
      }
      if (e.target.closest(".lk-zb, .garr")) return;
      const t = e.touches[0];
      t0 = { x: t.clientX, y: t.clientY, ox, oy };
    }, { passive: true });
    gm.addEventListener("touchmove", (e) => {
      if (pinch && e.touches.length === 2) {
        e.preventDefault();
        const [a, b] = e.touches;
        Z = clampN(pinch.z * dist(a, b) / pinch.d, 1, MAXZ);
        moved = true;
        paint(false);
        return;
      }
      if (!t0) return;
      const t = e.touches[0], dx = t.clientX - t0.x, dy = t.clientY - t0.y;
      if (Math.abs(dx) + Math.abs(dy) > 8) moved = true;
      if (Z <= 1) return;
      e.preventDefault();
      const r = box();
      ox = clampN(t0.ox - dx / (Z - 1), 0, r.width);
      oy = clampN(t0.oy - dy / (Z - 1), 0, r.height);
      const s = slides[g];
      if (s) s.style.transformOrigin = `${ox}px ${oy}px`;
    }, { passive: false });
    gm.addEventListener("touchend", (e) => {
      if (pinch) {
        if (e.touches.length < 2) {
          pinch = null;
          if (Z < 1.05) unzoom();
          else paint(true);
        }
        return;
      }
      if (t0 && !mob() && Z <= 1) {
        const d = e.changedTouches[0].clientX - t0.x;
        if (Math.abs(d) > 40) go(g + (d < 0 ? 1 : -1));
      }
      t0 = null;
      if (moved) setTimeout(() => { moved = false; }, 350);
    });
    document.addEventListener("keydown", (e) => {
      if (!document.contains(gm)) return;
      if (/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) || window.Lymko.isOpen()) return;
      if (e.key === "ArrowRight") go(g + 1);
      if (e.key === "ArrowLeft") go(g - 1);
      if (e.key === "Escape") unzoom();
      if (e.key === "+" || e.key === "=") setZ(Z + 0.75);
      if (e.key === "-" || e.key === "_") setZ(Z - 0.75);
    });
    let lastW = innerWidth;
    addEventListener("resize", () => {
      if (innerWidth !== lastW) {
        lastW = innerWidth;
        if (Z > 1) unzoom();
      }
    });
    const form = $("#pform");
    if (!form) return;
    const qn = $("#qn"), btn = $("#qadd"), vid = $("[data-vid]", form), err = $("#perr");
    let unit = Number(btn.dataset.unit || 0);
    const label = () => {
      if (!btn.disabled) btn.textContent = `${btn.dataset.label || T("add_to_bag", "Add to bag")} — ${money(unit * Math.max(1, Number(qn.value) || 1))}`;
    };
    const clamp = (v) => Math.max(1, Math.min(Number(CFG.maxQty) || 20, Math.floor(Number(v) || 1)));
    $("#qm").addEventListener("click", () => {
      qn.value = clamp(+qn.value - 1);
      label();
    });
    $("#qp").addEventListener("click", () => {
      qn.value = clamp(+qn.value + 1);
      label();
    });
    qn.addEventListener("change", () => {
      qn.value = clamp(qn.value);
      label();
    });
    let vAvail = !btn.disabled;
    const vj = $("[data-variants]", form);
    if (vj) {
      const variants = JSON.parse(vj.textContent);
      const bn0 = $("#buynow");
      $$("[data-opt]", form).forEach((s) => s.addEventListener("change", () => {
        const sel = $$("[data-opt]", form).map((x) => x.value);
        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        const stock = $("[data-stock]"), sku = $("[data-sku]"), cmp = $("[data-compare]"), sv = $("[data-save]");
        if (!v) {
          vAvail = false;
          btn.disabled = true;
          btn.textContent = T("unavailable", "Unavailable");
          if (bn0) bn0.hidden = true;
          if (stock) stock.textContent = T("unavailable", "Unavailable");
          return;
        }
        vid.value = v.id;
        unit = v.price;
        vAvail = !!v.available;
        btn.disabled = !vAvail;
        if (bn0) bn0.hidden = !vAvail;
        const pr = $("[data-price]");
        if (pr) pr.textContent = money(v.price);
        const on = v.compare_at_price > v.price;
        if (cmp) {
          cmp.hidden = !on;
          cmp.textContent = on ? money(v.compare_at_price) : "";
        }
        if (sv) {
          sv.hidden = !on;
          if (on) sv.textContent = (sv.dataset.tpl || "Save [n]%").replace("[n]", Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100));
        }
        if (stock) stock.textContent = v.available ? stock.dataset.in || "In stock" : stock.dataset.out || "Sold out";
        if (sku) {
          sku.hidden = !v.sku;
          sku.textContent = v.sku ? ` · ${sku.dataset.label || "SKU"} ${v.sku}` : "";
        }
        if (vAvail) label();
        else btn.textContent = btn.dataset.soldout || "Sold out";
        if (v.media_id) {
          const i = slides.findIndex((x) => x.dataset.mediaId === String(v.media_id));
          if (i > -1) go(i);
        }
        try {
          const u = new URL(location.href);
          u.searchParams.set("variant", v.id);
          history.replaceState(null, "", u);
        } catch (x) {
        }
      }));
    }
    const doAdd = async () => {
      if (!vAvail) return false;
      err.textContent = "";
      btn.disabled = true;
      try {
        await addItems([{ id: Number(vid.value), quantity: clamp(qn.value) }]);
        return true;
      } catch (e) {
        err.textContent = e.message;
        return false;
      } finally {
        btn.disabled = !vAvail;
        if (vAvail) label();
      }
    };
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (await doAdd()) {
        if (CFG.openDrawer === false) toast(window.Lymko.T ? window.Lymko.T("added", "Added to your bag") : "Added to your bag");
        else openO("cart");
      }
    });
    const bn = $("#buynow");
    if (bn) bn.addEventListener("click", async () => {
      if (await doAdd()) location.href = window.Lymko.U ? window.Lymko.U("checkout") : "/checkout";
    });
  }
  function boughtTogether() {
    const fb = $("[data-fbt]");
    if (fb && !fb.dataset.lkBound) {
      fb.dataset.lkBound = 1;
      const combos = JSON.parse(($("[data-fbt-combos]") || { textContent: "[]" }).textContent);
      const calc = () => {
        const on = $$("[data-fb]", fb).filter((x) => x.checked);
        $("#fbtot").textContent = money(on.reduce((s, x) => s + Number(x.dataset.price), 0));
        const ids = on.map((x) => x.dataset.h);
        const c = combos.find((c2) => c2.items.length === ids.length && ids.every((i) => c2.items.includes(i)));
        const tpl = esc(fb.dataset.tpl || "Or get them as [name] for [price]");
        $("#fbc").innerHTML = c && ids.length > 1 ? tpl.replace("[name]", `<a class="link" href="${esc(c.url)}">${esc(c.name)}</a>`).replace("[price]", money(c.price)) : "";
        return on.map((x) => ({ id: Number(x.dataset.fb), quantity: 1 }));
      };
      fb.addEventListener("change", calc);
      calc();
      const fa = $("#fbadd");
      fa.addEventListener("click", async () => {
        const items = calc();
        if (!items.length) return;
        fa.disabled = true;
        try {
          await addItems(items);
          openO("cart");
        } catch (e) {
          toast(e.message);
        } finally {
          fa.disabled = false;
        }
      });
    }
  }
  const init = () => {
    productPage();
    boughtTogether();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
